import { render, staticRenderFns } from "./ContributionDeclarationForm.vue?vue&type=template&id=04421a68&"
import script from "./ContributionDeclarationForm.vue?vue&type=script&lang=js&"
export * from "./ContributionDeclarationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports